/*global Modernizr, console */
/*jslint browser:true */

(function() {
    'use strict';

    let ticking = false;

    // 100vw doesn't take into account for the scrollbar. So we do that by setting a CSS variable.
    function _calculateVariables() {
        if(document.documentElement.clientWidth <= 1030) {
            document.documentElement.style.setProperty('--header-height', "64px");
        } else {
            document.documentElement.style.setProperty('--header-height', (document.querySelector('header').offsetHeight) + "px");
        }
    }

    document.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                _calculateVariables();
                ticking = false;
            });

            ticking = true;
        }
    }, { passive: true });

    // recalculate on resize
    window.addEventListener('resize', _calculateVariables, false);
    // recalculate on dom load
    document.addEventListener('DOMContentLoaded', _calculateVariables, false);
    // recalculate on load (assets loaded as well)
    window.addEventListener('load', _calculateVariables);
}());
